export enum EreSelectionSteps {
    NONE = "",
    SUMMARY = "summary",
    EXTERN = "extern",
    CALCULATION = "calculation",
    DETAILS = "details",
}
